import React from 'react';
import referencesService from '../../services/references';
import useReferenceList from './useReferenceList';
import { useSnackbar } from 'notistack';
import Progress from './Progress';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { FormControl, FormLabel, FormGroup } from '@material-ui/core';
import styled from 'styled-components';

interface Props {
  pitches: { [key: string]: boolean };
  onPitchesChange: (pitches: { [key: string]: boolean }) => void;
}

const Wrapper = styled.div`
  margin-top: 16px;
  margin-bottom: 16px;
`;

const SelectPitch: React.FunctionComponent<Props> = (props) => {
  const { data, error, loading } = useReferenceList('pitches', referencesService.getPitches);
  const { enqueueSnackbar } = useSnackbar();

  const onChange = (id: string, event: React.ChangeEvent<HTMLInputElement>) => {
    if (!event.target.checked) {
      delete props.pitches[id];
      props.onPitchesChange({ ...props.pitches });
    } else {
      props.onPitchesChange({ ...props.pitches, [id]: event.target.checked });
    }
  };

  if (error) {
    enqueueSnackbar('Failed to load pitches', { variant: 'error', autoHideDuration: 3000 });
  }

  if (loading || !data) {
    return <Progress />;
  }
  return (
    <Wrapper>
      <FormControl component="fieldset">
        <FormLabel component="legend">Select pitches</FormLabel>
        <FormGroup>
          {data
            .slice()
            .sort((a, b) => a.name.localeCompare(b.name))
            .map((s) => (
              <FormControlLabel
                key={s.id}
                control={
                  <Checkbox
                    checked={props.pitches[String(s.id)] || false}
                    onChange={(event) => onChange(String(s.id), event)}
                    value={String(s.id)}
                  />
                }
                label={s.name}
              />
            ))}
        </FormGroup>
      </FormControl>
    </Wrapper>
  );
};

export default SelectPitch;
